import { render, staticRenderFns } from "./StoresList.vue?vue&type=template&id=bd250d50&scoped=true&"
import script from "./StoresList.vue?vue&type=script&lang=js&"
export * from "./StoresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd250d50",
  null
  
)

export default component.exports